import util from "../util";
import {refreshPageIds} from "./page";
import History from "./history";
import {getElementsPositions} from "./position";
import {updatePageBars} from "./selection";
import Interactable from "./interactable";
import {AlignDirection, AlignType} from "./interactable-constants";

export function multiAlign($elements, key) {
    if ($elements.length === 1) {
        multiAlignSingle($elements[0], key);
        updatePageBars($elements[0]);
        return;
    }

    const pageWidth = util.getActiveDimensions().width;
    const pageHeight = util.getActiveDimensions().height;

    function doAction($elements) {
        const MULTIALIGN_WITH_MOVEABLE = true;

        if (MULTIALIGN_WITH_MOVEABLE) {
            let alignType = AlignType.HORIZONTAL;
            let alignDirection = AlignDirection.END;

            if (key === 'top') {
                alignType = AlignType.HORIZONTAL;
                alignDirection = AlignDirection.START;
            } else if (key === 'bottom') {
                alignType = AlignType.HORIZONTAL;
                alignDirection = AlignDirection.END;
            } else if (key === 'left') {
                alignType = AlignType.VERTICAL;
                alignDirection = AlignDirection.START;
            } else if (key === 'right') {
                alignType = AlignType.VERTICAL;
                alignDirection = AlignDirection.END;
            } else if (key === 'center-vertical') {
                alignType = AlignType.VERTICAL;
                alignDirection = AlignDirection.CENTER;
            } else if (key === 'center-horizontal') {
                alignType = AlignType.HORIZONTAL;
                alignDirection = AlignDirection.CENTER;
            }

            Interactable.alignElements($('#pages')[0], $elements, alignType, alignDirection);
        } else {
            const result = getElementsPositions($elements);
            const {top} = result;
            const {left} = result;
            const {bottom} = result;
            const {right} = result;
            const {width} = result;
            const {height} = result;
            const {maxHeightTop} = result;
            const {maxWidthLeft} = result;

            $elements.forEach(($element) => {
                $element.attr('data-original-top', $element.css('top'));
                $element.attr('data-original-left', $element.css('left'));

                if ($element.hasClass('locked')) {
                    return true;
                }

                const isGroup = util.isGroup($element);
                const sideOffset = isGroup ? constants.GROUP_ASIDE_SPACE_BUFFER : 0;

                if (key === 'top') {
                    $element.css('top', `${util.pixelToPercent(top, pageHeight)}%`);
                } else if (key === 'bottom') {
                    $element.css('top', `${util.pixelToPercent((bottom - $element.height()), pageHeight)}%`);
                } else if (key === 'left') {
                    $element.css('left', `${util.pixelToPercent(left - sideOffset, pageWidth)}%`);
                } else if (key === 'right') {
                    $element.css('left', `${util.pixelToPercent((right - $element.width() + sideOffset), pageWidth)}%`);
                } else if (key === 'center-vertical') {
                    $element.css('left', `${util.pixelToPercent((maxWidthLeft + ((width - $element.width()) / 2)), pageWidth)}%`);
                } else if (key === 'center-horizontal') {
                    $element.css('top', `${util.pixelToPercent((maxHeightTop + ((height - $element.height()) / 2)), pageHeight)}%`);
                }
                updatePageBars($element);
            })
        }
    }

    function undoAction($elements) {
        $elements.forEach(($element) => {
            $element.css('top', `${util.pixelToPercent(parseFloat($element.attr('data-original-top')), pageHeight)}%`);
            $element.css('left', `${util.pixelToPercent(parseFloat($element.attr('data-original-left')), pageWidth)}%`);
        });
    }

    const $finals = [];
    $elements.forEach(($element) => {
        const $group = $element.parents('.group');
        $finals.push($group.length > 0 ? $group : $element);
    });

    const redo = () => doAction($finals);
    const undo = () => undoAction($finals);

    redo();
    History.push(undo, redo, 'Align');
}

export function getRotationDegrees(obj) {
    const matrix = obj.css('-webkit-transform')
        || obj.css('-moz-transform')
        || obj.css('-ms-transform')
        || obj.css('-o-transform')
        || obj.css('transform');

    let angle = 0;

    if (matrix !== 'none') {
        const values = matrix.split('(')[1].split(')')[0].split(',');
        const a = parseFloat(values[0]);
        const b = parseFloat(values[1]);
        angle = Math.round(Math.atan2(b, a) * (180 / Math.PI));
    }
    return (angle < 0) ? angle + 360 : angle;
}

function multiAlignSingle($element, key) {
    if (util.isInGroup($element)) {
        $element = $element.parents('.group');
    }

    const dims = util.getActiveDimensions();
    const pageHeight = dims.height;
    const pageWidth = dims.width;

    const bleedWidthPercent = dims.unit === 'in' ? util.inchToPercent(0.25, pageWidth) : 0;
    const bleedHeightPercent = dims.unit === 'in' ? util.inchToPercent(0.25, pageHeight) : 0;
    const halfBleedWidthPercent = dims.unit === 'in' ? util.inchToPercent(0.25 / 2, pageWidth) : 0;

    let {top} = $element.get(0).style;
    let {left} = $element.get(0).style;

    const interactable = Interactable.of($element);//!util.isFrame($element) && !util.isFramePreview($element) ? Interactable.of($element) : null;

    refreshPageIds();

    if (key === 'top') {
        if (interactable) {
            interactable.alignTop();
        } else {
            top = `${bleedHeightPercent}%`;
        }
    } else if (key === 'bottom') {
        if (interactable) {
            interactable.alignBottom();
        } else {
            top = `${util.pixelToPercent((pageHeight - $element.height()), pageHeight) - bleedHeightPercent}%`;
        }
    } else if (key === 'left') {
        if (interactable) {
            interactable.alignLeft();
        } else {
            left = `${bleedWidthPercent}%`;

            if (dims.hasFolds) {
                const page = util.getPageNumber($element);
                const panel = util.getPanelFold($element);

                switch (page) {
                    case 1:
                        if (panel === 1) `${bleedWidthPercent}%`;
                        if (panel === 2) left = `${util.inchToPercent(dims.pageOneFoldOne, pageWidth) + halfBleedWidthPercent}%`;
                        if (panel === 3) left = `${util.inchToPercent(dims.pageOneFoldTwo, pageWidth) + halfBleedWidthPercent}%`;
                        if (panel === 4) left = `${util.inchToPercent(dims.pageOneFoldThree, pageWidth) + halfBleedWidthPercent}%`;
                        break;
                    case 2:
                        if (panel === 1) `${bleedWidthPercent}%`;
                        if (panel === 2) left = `${util.inchToPercent(dims.pageTwoFoldOne, pageWidth) + halfBleedWidthPercent}%`;
                        if (panel === 3) left = `${util.inchToPercent(dims.pageTwoFoldTwo, pageWidth) + halfBleedWidthPercent}%`;
                        if (panel === 4) left = `${util.inchToPercent(dims.pageTwoFoldThree, pageWidth) + halfBleedWidthPercent}%`;
                        break;
                }
            } else if (getRotationDegrees($element) > 0) {
                $element.css('left', left);
                const boundingLeft = $element[0].getBoundingClientRect().left;
                const pageLeft = $element.parents('.page')[0].getBoundingClientRect().left;

                left = (boundingLeft - pageLeft) / pageWidth * 100 * -1;
                left += '%';
            }
        }
    } else if (key === 'right') {
        if (interactable) {
            interactable.alignRight();
        } else {
            left = `${util.pixelToPercent((pageWidth - $element.width()), pageWidth) - bleedWidthPercent}%`;

            if (dims.hasFolds) {
                const page = util.getPageNumber($element);
                const panel = util.getPanelFold($element);

                switch (page) {
                    case 1:
                        if (panel === 1) left = `${util.pixelToPercent((util.inchToPixel(dims.pageOneFoldOne) - $element.width()), pageWidth) - halfBleedWidthPercent}%`;
                        if (panel === 2) {
                            if (dims.pageOneFoldTwo) {
                                left = `${util.pixelToPercent((util.inchToPixel(dims.pageOneFoldTwo) - $element.width()), pageWidth) - halfBleedWidthPercent}%`;
                            } else {
                                left = `${util.pixelToPercent((pageWidth - $element.width()), pageWidth) - bleedWidthPercent}%`;
                            }
                        }
                        if (panel === 3) {
                            if (dims.pageOneFoldThree) {
                                left = `${util.pixelToPercent((util.inchToPixel(dims.pageOneFoldThree) - $element.width()), pageWidth) - halfBleedWidthPercent}%`;
                            } else {
                                left = `${util.pixelToPercent((pageWidth - $element.width()), pageWidth) - bleedWidthPercent}%`;
                            }
                        }
                        if (panel === 4) left = `${util.pixelToPercent((pageWidth - $element.width()), pageWidth) - bleedWidthPercent}%`;
                        break;
                    case 2:
                        if (panel === 1) left = `${util.pixelToPercent((util.inchToPixel(dims.pageTwoFoldOne) - $element.width()), pageWidth) - halfBleedWidthPercent}%`;
                        if (panel === 2) {
                            if (dims.pageTwoFoldTwo) {
                                left = `${util.pixelToPercent((util.inchToPixel(dims.pageTwoFoldTwo) - $element.width()), pageWidth) - halfBleedWidthPercent}%`;
                            } else {
                                left = `${util.pixelToPercent((pageWidth - $element.width()), pageWidth) - bleedWidthPercent}%`;
                            }
                        }
                        if (panel === 3)
                            if (dims.pageTwoFoldThree) {
                                left = `${util.pixelToPercent((util.inchToPixel(dims.pageTwoFoldThree) - $element.width()), pageWidth) - halfBleedWidthPercent}%`;
                            } else {
                                left = `${util.pixelToPercent((pageWidth - $element.width()), pageWidth) - bleedWidthPercent}%`;
                            }
                        if (panel === 4) left = `${util.pixelToPercent((pageWidth - $element.width()), pageWidth) - bleedWidthPercent}%`;
                        break;
                }
            }
        }
    } else if (key === 'center-vertical') {
        if (interactable) {
            interactable.alignCenter();
        } else {
            const elWidth = parseFloat($element.width());
            left = `${util.pixelToPercent(((pageWidth) / 2) - (elWidth / 2), pageWidth)}%`;

            if (dims.hasFolds) {
                const page = util.getPageNumber($element);
                const panel = util.getPanelFold($element);

                const halfHalfBleedWidth = util.inchToPixel(0.25 / 2 / 2);

                switch (page) {
                    case 1:
                        if (panel === 1) left = `${util.pixelToPercent(((util.inchToPixel(dims.pageOneFoldOne)) / 2) - (elWidth / 2) + halfHalfBleedWidth, pageWidth)}%`;
                        if (panel === 2) {
                            if (dims.pageOneFoldTwo) {
                                left = `${util.pixelToPercent(util.inchToPixel(dims.pageOneFoldOne) + ((util.inchToPixel(dims.pageOneFoldTwo) - util.inchToPixel(dims.pageOneFoldOne)) / 2) - (elWidth / 2), pageWidth)}%`;
                            } else {
                                left = `${util.pixelToPercent(util.inchToPixel(dims.pageOneFoldOne) + ((pageWidth - util.inchToPixel(dims.pageOneFoldOne) - util.inchToPixel(.1)) / 2) - (elWidth / 2), pageWidth)}%`;
                            }
                        }
                        if (panel === 3) {
                            if (dims.pageOneFoldThree) {
                                left = `${util.pixelToPercent(util.inchToPixel(dims.pageOneFoldTwo) + ((util.inchToPixel(dims.pageOneFoldThree) - util.inchToPixel(dims.pageOneFoldTwo)) / 2) - (elWidth / 2), pageWidth)}%`;
                            } else {
                                left = `${util.pixelToPercent(util.inchToPixel(dims.pageOneFoldTwo) + ((pageWidth - util.inchToPixel(dims.pageOneFoldTwo) - util.inchToPixel(.1)) / 2) - (elWidth / 2), pageWidth)}%`;
                            }
                        }
                        if (panel === 4) left = `${util.pixelToPercent(util.inchToPixel(dims.pageOneFoldThree) + ((pageWidth - util.inchToPixel(dims.pageOneFoldThree)) / 2) - (elWidth / 2) - halfHalfBleedWidth, pageWidth)}%`;
                        break;
                    case 2:
                        if (panel === 1) left = `${util.pixelToPercent(((util.inchToPixel(dims.pageTwoFoldOne)) / 2) - (elWidth / 2) + halfHalfBleedWidth, pageWidth)}%`;
                        if (panel === 2) {
                            if (dims.pageTwoFoldTwo) {
                                left = `${util.pixelToPercent(util.inchToPixel(dims.pageTwoFoldOne) + ((util.inchToPixel(dims.pageTwoFoldTwo) - util.inchToPixel(dims.pageTwoFoldOne)) / 2) - (elWidth / 2), pageWidth)}%`;
                            } else {
                                left = `${util.pixelToPercent(util.inchToPixel(dims.pageTwoFoldOne) + ((pageWidth - util.inchToPixel(dims.pageTwoFoldOne) - util.inchToPixel(.1)) / 2) - (elWidth / 2), pageWidth)}%`;
                            }
                        }
                        if (panel === 3) {
                            if (dims.pageTwoFoldThree) {
                                left = `${util.pixelToPercent(util.inchToPixel(dims.pageTwoFoldTwo) + ((util.inchToPixel(dims.pageTwoFoldThree) - util.inchToPixel(dims.pageTwoFoldTwo)) / 2) - (elWidth / 2), pageWidth)}%`;
                            } else {
                                left = `${util.pixelToPercent(util.inchToPixel(dims.pageTwoFoldTwo) + ((pageWidth - util.inchToPixel(dims.pageTwoFoldTwo) - util.inchToPixel(.1)) / 2) - (elWidth / 2), pageWidth)}%`;
                            }
                        }
                        if (panel === 4) left = `${util.pixelToPercent(util.inchToPixel(dims.pageTwoFoldThree) + ((pageWidth - util.inchToPixel(dims.pageTwoFoldThree)) / 2) - (elWidth / 2) - halfHalfBleedWidth, pageWidth)}%`;
                        break;
                }
            }
        }
    } else if (key === 'center-horizontal') {
        if (interactable) {
            interactable.alignMiddle();
        } else {
            const elHeight = parseFloat($element.height());
            top = `${util.pixelToPercent(((pageHeight) / 2) - (elHeight / 2), pageHeight)}%`;
        }
    }

    if (!interactable) {
        function doAction($element, top, left) {
            $element.attr('data-original-top', top);
            $element.attr('data-original-left', left);
            $element.css('top', top);
            $element.css('left', left);

            Interactable.of($element).refreshPosition();
        }

        const $group = $element.parents('.group');
        if ($group.length > 0) $element = $group;

        const oldLeft = $element.get(0).style.left;
        const oldTop = $element.get(0).style.top;

        const redo = () => doAction($element, top, left);
        const undo = () => doAction($element, oldTop, oldLeft);

        redo();
        History.push(undo, redo, 'Align');
    }
}
